<div class="recent-menu-content">
    <div class="workspace-selection-menu"
      [popover]="customTooltipTemplate" triggers="click"
      placement="bottom left"
      containerClass="ws-category-list"
      container="body">
  <button class="btn btn-default menu-toggle">
      <i class="wm-icon wms wms-workspace-icon"></i>
      <!-- <i class="wm-icon wms wms-history" *ngIf="activeWS.type === 'EMPTY'"></i> -->
      <!-- <span class="ws-name" title="{{activeWS?.name}}">
          <span class="title">{{activeWS?.name || locale.LABEL_RECENT_ITEMS}}</span>
          <span class="dirty-icon" *ngIf="activeWS.active && isActiveWSDirty()">*</span>
      </span> -->
    </button>
  <!-- <span class="ws-menu-arrow"></span> -->
  </div>
</div>
<ng-template #customTooltipTemplate>
  <div class="tooltip-content">
    <ul class="ws-menu" (mouseenter)="onPopOverMouseEnter($event)" (mouseleave)="hideTooltiponleave()" >
      <li *ngFor="let categoryInfo of wsCategories">
        <div class="ws-category">
          <span><i class="wms wms-{{categoryInfo.icon}}"></i>{{categoryInfo.displayName}}</span>
        </div>
        <div class="ws-category-item-list">
          <a class="ws-category-list-item" [hidden]="!recentWSListByCategory[categoryInfo.id]" *ngFor="let ws of recentWSListByCategory[categoryInfo.id]" (click)="onSelect(ws);" [ngClass]="{active: ws.active }" [attr.name]="ws.active ? 'ACTIVE_PAGE_NAME' : null" title="{{ws.name}}">
            <span>{{ws.name}}</span>
          </a>
          <p class="ws-list-empty-text text-muted" *ngIf="!recentWSListByCategory[categoryInfo.id]">{{locale.LABEL_CATEGORY_LIST_PLACEHOLDER_TEXT}}.</p>
        </div>
      </li>
    </ul>
  </div>
</ng-template>

